import { render } from "./ListSubmittals.vue?vue&type=template&id=f7f2c58c&scoped=true"
import script from "./ListSubmittals.vue?vue&type=script&lang=js"
export * from "./ListSubmittals.vue?vue&type=script&lang=js"

import "./ListSubmittals.vue?vue&type=style&index=0&id=f7f2c58c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7f2c58c"]])

export default __exports__